import { ColumnDef } from '@tanstack/react-table';

import { AmendmentListItem } from '@xemplo/gp-types';

import { AmendmentListWidgetCell } from './amendment-list-widget-cell';
export const columns: ColumnDef<AmendmentListItem>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => <AmendmentListWidgetCell {...row} />,
  },
];
